<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="Chapter-title-14">Contents</p>
<p class="TOC-text"><a href="#/00.5_MaryMe_intro#toc_marker-1">Introduction</a></p>
<p class="TOC-text"><a href="#/MaryMe_01#toc_marker-2">First Meetings</a></p>
<p class="TOC-text"><span href="#/MaryMe_02#toc_marker-3" title="Link target outside of Sample">Mothers</span></p>
<p class="TOC-text"><span href="#/MaryMe_03#toc_marker-4" title="Link target outside of Sample">Mean Girls</span></p>
<p class="TOC-text"><span href="#/MaryMe_04#toc_marker-5" title="Link target outside of Sample">Oh, Baby!</span></p>
<p class="TOC-text"><span href="#/MaryMe_05#toc_marker-6" title="Link target outside of Sample">The Write Stuff</span></p>
<p class="TOC-text"><span href="#/MaryMe_06#toc_marker-7" title="Link target outside of Sample">In Sickness and in Health</span></p>
<p class="TOC-text"><span href="#/MaryMe_07#toc_marker-8" title="Link target outside of Sample">When Jealousy Rears Its Ugly Head</span></p>
<p class="TOC-text"><span href="#/MaryMe_08#toc_marker-9" title="Link target outside of Sample">Who, Me? Worry?</span></p>
<p class="TOC-text"><span href="#/MaryMe_09#toc_marker-10" title="Link target outside of Sample">Losses</span></p>
<p class="TOC-text"><span href="#/MaryMe_10#toc_marker-11" title="Link target outside of Sample">Faith</span></p>
<p class="TOC-text"><span href="#/MaryMe_11#toc_marker-12" title="Link target outside of Sample">Sex, Drugs, and Rock &amp; Roll: What We Don’t Talk About</span></p>
<p class="TOC-text"><span href="#/MaryMe_12#toc_marker-13" title="Link target outside of Sample">Letter Writing 101</span></p>
<p class="TOC-text"><span href="#/MaryMe_13#toc_marker-14" title="Link target outside of Sample">Postscript</span></p>
<p class="TOC-text"><span href="#/MaryMe_14#toc_marker-15" title="Link target outside of Sample">Suggested Resources</span></p>
<p class="TOC-text"><span href="#/MaryMe_15#toc_marker-16" title="Link target outside of Sample">Discussion Questions</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00.4_MaryMe.vue?555b5bbb